import {api_header} from "~/types/api_header";

export default function () {
    const options = (params: any = {}) => {
        return {
            baseURL: String(useNuxtApp().$apiUrl()),
            headers: api_header(),
            ...params
        }
    }

    const fetchChain = (inputs: string[]) => {
        const res: any[] = []

        for (const api of inputs) {
            res.push($fetch(api, options()),)
        }

        return res
    }

    const push = (chain: any[], api: string) => {
        if (!chain)
            return chain

        chain.push($fetch(api, options()))

        return chain
    }

    const method = (id: string|null) => {
        return id ? 'PATCH' : 'POST'
    }

    return {
        options,
        fetchChain,
        push,
        method
    }
}
